import { useEffect, useRef, useState } from "react";
import { getOrganizationList } from "api/PowerUserHelpers";

export const fetchAllOrganizations = async (username) => {
  if (!username) return [];

  const { data } = await getOrganizationList({
    username,
    page: 0,
    pageSize: 500,
    all: true,
    sortBy: "GroupName",
    sortOrder: "asc",
  });

  return data.Groups || [];
};

const useOrganizations = (username, query, refreshKey = 0) => {
  const {
    page = 0,
    pageSize = 10,
    sortBy = "",
    sortOrder = "",
    filterColumn = "",
    filterType = "",
    filterValue,
  } = query || {};
  const [isLoading, setIsLoading] = useState(true);
  const [orgList, setOrgList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const requestId = useRef(0);
  const previousRefreshKey = useRef(refreshKey);

  useEffect(() => {
    if (!username) {
      requestId.current += 1;
      setOrgList([]);
      setTotalCount(0);
      setIsLoading(false);
      return;
    }

    let isActive = true;
    const currentRequestId = requestId.current + 1;
    const refresh = previousRefreshKey.current !== refreshKey;
    requestId.current = currentRequestId;
    previousRefreshKey.current = refreshKey;
    setIsLoading(true);

    getOrganizationList({
      username,
      page,
      pageSize,
      refresh: refresh || undefined,
      sortBy: sortBy || undefined,
      sortOrder: sortOrder || undefined,
      filterColumn: filterColumn || undefined,
      filterType: filterType || undefined,
      filterValue,
    })
      .then(({ data }) => {
        if (!isActive || requestId.current !== currentRequestId) return;

        setOrgList(data.Groups || []);
        setTotalCount(data.TotalCount || 0);
      })
      .catch(() => {
        if (!isActive || requestId.current !== currentRequestId) return;

        setOrgList([]);
        setTotalCount(0);
      })
      .finally(() => {
        if (isActive && requestId.current === currentRequestId) {
          setIsLoading(false);
        }
      });

    return () => {
      isActive = false;
    };
  }, [filterColumn, filterType, filterValue, page, pageSize, refreshKey, sortBy, sortOrder, username]);

  return { isLoading, orgList, totalCount };
};

export default useOrganizations;
